import { render, staticRenderFns } from "./IndividualMedicine.vue?vue&type=template&id=5a422450&scoped=true"
import script from "./IndividualMedicine.vue?vue&type=script&lang=js"
export * from "./IndividualMedicine.vue?vue&type=script&lang=js"
import style0 from "./IndividualMedicine.vue?vue&type=style&index=0&id=5a422450&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a422450",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a422450')) {
      api.createRecord('5a422450', component.options)
    } else {
      api.reload('5a422450', component.options)
    }
    module.hot.accept("./IndividualMedicine.vue?vue&type=template&id=5a422450&scoped=true", function () {
      api.rerender('5a422450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proposal/IndividualMedicine.vue"
export default component.exports